import { HttpClient } from "@angular/common/http";
import { IResult } from "app/common/interfaces";
import { AbstractService } from "app/services/abstract.service";
import { environment as env } from "../../../../../../environments/environment.prod";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import BusinessPartnerContactAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/business-partners/business-partners-contact/business-partners-contact.entity";
import { ICreateBusinessPartnerContact } from "./interfaces/create-business-partner-contact.interface";
import { IUpdateBusinessPartnerContact } from "./interfaces/update-business-partner-contact.interface";
const apiUrl = env.API_BUSINESS_PARTNER;
const moduleName = "business_partner_contact";

@Injectable({
  providedIn: "root",
})
export class BusinessPartnerContactService extends AbstractService<
BusinessPartnerContactAttributes,
ICreateBusinessPartnerContact,
IUpdateBusinessPartnerContact
> {
  constructor(
    http: HttpClient,
  ) {
    super(apiUrl, moduleName, http);
  }

  /**
   * Pagination
   * @param options Pagination options
   * @returns Paginated data
   */
  findByBusinessId(businessId: string): Observable<IResult<BusinessPartnerContactAttributes>> {
    const API_URL: string = `${apiUrl}api/${moduleName}/${businessId}`;
    return this.http.get<IResult<BusinessPartnerContactAttributes>>(API_URL);
  }
}